<template>
  <div class="central-control-station">
    <div class="title">Cofocus</div>
    <div class="controls-container" :style="verifiedStyle">
      <!-- <span class="title">VERIFY</span> -->
      <div class="central-controls">
        <div v-if="user && !user.verificationStatus" class="welcome">
          <span class="text">Welcome!</span>
        </div>
        <div v-if="user && !user.verificationStatus">
          <div class="verify">
            <span class="text">Please verify your email address.</span>
          </div>
          <div @click="resendEmail" class="join" :style="resendWidth">
            {{ resendText }}
          </div>
          <transition name="fade">
            <span class="success" v-if="success">Email sent. Don't forget to check spam.</span>
          </transition>
        </div>
        <div v-else-if="(user && user.verificationStatus) || isVerified">
          <div class="verified-container">
            <div class="verified">
              <IconBase icon-name="verified" iconColor="#252525" viewBox="0 0 512 512" width="44" height="44"><IconVerified /></IconBase>
              <span class="text">Verified.</span>
            </div>
          </div>
          <div class="verified">
            <span class="small"
              >Before we let you on Cofocus, we ask you to enter your full name. This is because real names help build trust in the community. Thank
              you!</span
            >
          </div>
          <form @submit.prevent="completeSignup" class="auth-form" method="POST">
            <div class="form-groups">
              <div class="form-group">
                <input v-model="firstName" class="auth-input" name="username" type="text" placeholder="First name" autocomplete="off" />
              </div>
              <div class="form-group">
                <input v-model="lastName" class="auth-input" name="username" type="text" placeholder="Last name" autocomplete="off" />
              </div>
            </div>
            <transition name="fade">
              <span class="fail" v-if="error">Please provide both the first and last name.</span>
            </transition>
            <div class="submit">
              <input :disabled="submitting" class="auth-button" type="submit" :value="completeText" />
            </div>
          </form>
        </div>
      </div>
      <div v-if="user" class="logout" :class="getLogoutClass">
        <span class="text">Not {{ user.email }}?</span>
        <span @click="logUserOut" class="action">Log out.</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import auth from "../../config/auth";
import { requestWithAuthentication } from "../../config/api";
import api from "../../api/cofocusAPI";
import IconBase from "../../components/IconBase";
import IconVerified from "../../components/SVG/IconVerified";
import InternalAPI from "../../ELYX/Internal/InternalAPI";

/**
 *
 * 1. Welcome user
 * 2. Ask them to verify + explain why / if return && not verified, option to resend verification email
 * 3. Ask them to provide a first name & last name (both) (allow display name change later, start w/initial) + explain why necessary, community & culture --> create a display name w/last initial
 * 4. Optional / add later (profile picture)
 * 5. Allow link to join Booking Dashboard + present option to add task
 *  5.1 --> If first time (e.g. if !introComplete), show instruction video
 *
 *
 */

export default {
  name: "RegisterFlow",
  data() {
    return {
      resendText: "Resend email",
      resendWidth: "max-width: 215px !important;",
      success: false,
      emailSentCounter: 0,
      error: false,
      firstName: "",
      lastName: "",
      submitting: false,
      completeText: "Start focusing",
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      isAuthenticated: (state) => state.auth.authenticationStatus,
      isVerified: (state) => state.auth.verificationStatus,
    }),

    verifiedStyle() {
      let verificationStyle = "";
      if (this.user && this.user.verificationStatus) {
        verificationStyle = "padding: 55px 100px;";
      }
      return verificationStyle;
    },

    getLogoutClass() {
      let logoutClass = "";
      if (this.user && this.user.verificationStatus) {
        logoutClass = "verifiedLogout";
      }
      return logoutClass;
    },
  },

  created() {
    if (this.isAuthenticated && this.user && this.user.verificationStatus && this.user.displayName) {
      /** Sometimes users could press back button to get
       * back to this page && bypass Vue router checks */
      /* this.$router.push("/"); */
      window.location = "/";
    }
  },

  components: {
    IconBase,
    IconVerified,
  },
  methods: {
    async completeSignup() {
      this.submitting = true;
      this.error = false;
      if (!this.firstName || !this.lastName || !this.user || !this.user._id) {
        console.log("uh");
        this.error = true;
        return;
      }

      if (!this.firstName.trim().length || !this.lastName.trim().length) {
        console.log("eh");
        this.error = true;
        return;
      }

      this.completeText = "Completing signup...";
      try {
        const { firstName, lastName } = this;
        const lastNameInitial = lastName.charAt();
        const displayName = firstName + " " + lastNameInitial + ".";
        // TODO add displayName calculation
        const sendData = {
          firstName,
          lastName,
          displayName,
          isSignupCompletion: true,
          email: this.user.email,
          referralID: window.FPROM && window.FPROM.data.tid ? window.FPROM.data.tid : null,
        };

        const response = await api.REQUEST({
          method: "patch",
          url: `api/users/${this.user._id}/profile`,
          data: sendData,
          withCredentials: true,
        });
        if (response.data.success) {
          window.mixpanel.track("Complete Signup");
          InternalAPI.logEvent("CompleteRegistration", "Post Registration Page");
          let displayName = response.data.displayName;
          await this.$store.dispatch("auth/setUserDisplayName", displayName);
          this.submitting = false;
          this.error = false;
          /* this.$router.push("/"); */
          window.location = "/";
        }
      } catch (error) {
        console.error("@completeSignup", error);
        this.error = true;
      }
    },

    async resendEmail() {
      try {
        console.log("@clicked");
        this.resendText = "Sending...";
        this.success = false;
        const response = await requestWithAuthentication("post", `/api/accounts/resendemailverification`, {
          hostname: window.location.host,
          userId: this.user._id,
        });
        console.log("respon", response);
        if (response.data.success && this.emailSentCounter < 5) {
          this.resendText = "Resend email again";
          this.resendWidth = "max-width: 280px !important;";
          this.success = true;
          setTimeout(() => {
            this.success = false;
          }, 10000);
          this.emailSentCounter += 1;
        }
      } catch (err) {
        console.log(err);
      }
    },

    async logUserOut() {
      try {
        const response = await auth.logout();
        if (response.data.success) {
          window.location.replace("/");
        }
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>

<style scoped>
/* COLORS
seashell
whitesmoke
lavender
lavenderblush
 */

/* .room-creator {
     display: flex;
     align-items: center;
 } */

.input-container {
  position: relative;
  display: flex;
  flex-direction: row;
}

.dice {
  position: absolute;
  right: -44px;
  max-width: 32px;
  cursor: pointer;
  margin: auto 0px;
  bottom: 0;
  top: 0;
}

.dice:hover {
  transition: 0.2s ease;
  transform: scale(1.07);
}

.slug {
  font-size: 50px;
  width: 416px;
  margin-left: 3px;
  padding: 5px;
  padding-left: 10px;
  font-family: "Nunito", sans-serif;
  border: none;
  border: 1px solid #e4e4ec82;
  font-weight: 400;
  border-radius: 4px;
  color: #6e00ff;
  /* background-color: #f7f7fb; */
  background-color: #f2f2f9;
  background-color: white;
}
.slug:focus {
  outline: none;
  background-color: #f2f2f9;
  color: #000;
  padding-left: 10px;
}

.slug-red {
  border: 1px solid #ac01024f;
}

.already-exists {
  margin-left: auto;
  width: 400px;
  color: #ab0000;
  font-weight: bold;
  padding: 12px;
  text-align: right;
}

.scaled {
  transform: scale(1.06);
  transition: 0.4s ease;
}

.events {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 200px)) !important;
  gap: 20px;
  width: 700px;
  padding-top: 20px;
}
.title,
.subtitle {
  font-size: 30px;
  font-weight: 600;
  /* margin-bottom: 15px; */
  color: #252525;
  padding: 5px;
  font-family: "Nunito", sans-serif;
  z-index: 9999;
  margin-left: auto;
  margin-right: auto;
}
.title {
  max-width: 950px;
  font-size: 50px;
  font-weight: 700;
  color: #c1c1c7;
  color: #a0a0ab;
  color: #6e00ff;
  color: black;
  color: #252525;
  z-index: 9999;
  cursor: default;
}

.subtitle {
  margin-top: -5px;
}

.notice {
  font-size: 25px;
}
.central-control-station {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100%;
}

.controls-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 175px 100px;
  background-color: #fbfbfb;
  padding-bottom: 60px;
  border-radius: 25px;
  margin-top: 65px;
  margin-bottom: 75px;
  border: 1px solid #eee;
  box-sizing: border-box;
  width: 725px;
}

.central-controls {
  /* max-width: 350px; */
  /* margin-top: 75px; */
  margin-top: -10px;
  /* margin-bottom: 150px; */
  /* margin-bottom: 60px; */
}
.join {
  outline: none;
  background-color: #252525;
  color: white;
  font-size: 28px;
  border: unset;
  padding: 10px 0px;
  width: 100%;
  border-radius: 4px;
  cursor: pointer;
  margin-left: auto;
  margin-right: auto;
  margin-top: 30px;
  max-width: 215px;
  font-family: "Nunito", sans-serif !important;
  font-weight: 700;
  display: block;
}
.join:hover {
  background-color: #37373a;
}

.logout {
  margin-top: 100px;
}

.verifiedLogout {
  margin-top: 25px;
}

.logout .text,
.logout .action {
  font-size: 19px;
  font-weight: 600;
  color: #454545;
  padding: 5px;
  font-family: "Nunito", sans-serif;
  z-index: 9999;
  cursor: default;
}

.verifiedLogout .text,
.verifiedLogout .action {
  color: #555;
}

.logout .action {
  text-decoration: underline;
  cursor: pointer;
}

.logout .action:hover {
  color: #6b6b6b;
}

.welcome {
  display: flex;
  flex-direction: row;
  max-width: 700px;
  margin: 0 auto;
}

.welcome .text {
  font-size: 65px;
  font-weight: 600;
  color: #252525;
  padding: 5px;
  font-family: "Nunito", sans-serif;
  z-index: 9999;
  margin-left: auto;
  margin-right: auto;
  margin-top: -5px;
  cursor: default;
}

.verify {
  display: flex;
  flex-direction: row;
  max-width: 456px;
  margin: 0 auto;
  margin-top: 15px;
  margin-bottom: 40px;
}

.verify .text {
  font-size: 30px;
  font-weight: 600;
  color: #252525;
  padding: 5px;
  font-family: "Nunito", sans-serif;
  z-index: 9999;
  margin-top: -5px;
  text-align: left;
  margin-left: auto;
  margin-right: auto;
  line-height: 50px;
  padding-left: initial;
  padding-right: initial;
  cursor: default;
}

.verified {
  display: flex;
  flex-direction: row;
  max-width: 456px;
  margin: 0 auto;
  margin-top: 15px;
  margin-bottom: 40px;
  align-items: center;
  justify-content: center;
}

.verified .text {
  font-size: 46px;
  font-weight: 600;
  color: #252525;
  padding: 5px;
  font-family: "Nunito", sans-serif;
  z-index: 9999;
  /* margin-top: -5px; */
  text-align: left;
  /* margin-left: auto; */
  /* margin-right: auto; */
  line-height: 50px;
  padding-left: initial;
  padding-right: initial;
  cursor: default;
  margin-left: 16px;
}

.verified .small {
  font-size: 18px;
  line-height: 23px;
}

.success {
  display: block;
  background-color: #eee;
  padding: 5px;
  color: #252525;
  font-size: 15px;
  font-weight: bold;
  border-radius: 360px;
  width: 280px;
  margin: 0 auto;
  margin-top: 15px;
  cursor: default;
}

.fail {
  display: block;
  background-color: #eee;
  padding: 9px 0px;
  font-size: 17px;
  font-weight: bold;
  border-radius: 360px;
  width: 98%;
  margin: 0 auto;
  margin-top: 0px;
  margin-bottom: 14px;
  cursor: default;
  box-sizing: border-box;
}

.auth-form {
  display: flex;
  flex-direction: column;
  margin-bottom: 25px;
  position: relative;
}

.form-groups {
  display: flex;
  text-align: center;
  flex-direction: column;
  justify-content: center;
}
.form-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
  justify-content: center;
  position: relative;
}

.auth-input {
  width: 100%;
  border: none;
  border: 1px solid #ececec;
  border-radius: 3px;
  caret-color: #666;
  padding: 8px 19px;
  font-size: 20px;
  font-family: "Nunito", sans-serif;
  transition: 0.2s ease;
  box-sizing: border-box;
  outline: none;
  border-radius: 360px;
}
.auth-input:focus,
.auth-input:hover {
  border-color: #dcdcdc;
}
.auth-button {
  outline: none;
  background-color: #252525;
  color: white;
  font-size: 23px;
  font-weight: bold;
  border: unset;
  padding: 6px;
  width: 98%;
  cursor: pointer;
  font-family: "Nunito", sans-serif;
  margin-top: 8px;
  border-radius: 360px;
}
.auth-button:hover {
  background-color: #37373a;
}

.inputErrorContainer {
  padding: 8px 0px;
  background-color: #f9f9f9;
  border-radius: 360px;
  margin-bottom: 5px;
  color: #a72143;
  font-weight: 600;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
